<template>
  <button :class="stepClass" @click="goToPage">
    {{ title }}
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import quotes from "@/assets/quotes";
import { useQuoteStore } from "@/stores/root/quote";

const activeClass = "active";
const inActiveClass = "inactive";
const defaultClass = "steps";
const quoteStore = useQuoteStore();
const props = defineProps({
  step: {
    type: String,
    default: "",
  },
});

const title = computed(() => {
  const newQuote = quotes[props.step];
  return newQuote.wizardTitle;
});

const stepClass = computed(() => {
  if (props.step == quoteStore.currentStep) {
    return `${activeClass} ${defaultClass}`;
  } else if (
    quotes[props.step]?.index > quotes[quoteStore.currentStep]?.index
  ) {
    return `${inActiveClass} ${defaultClass}`;
  } else {
    return defaultClass;
  }
});

/**
 * Go directly to a specific page.
 */
function goToPage() {
  quoteStore.done == false
    ? quoteStore.setQuoteStep(props.step)
    : (window.location.href = "/renters");
}
</script>
